// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__mwJhx","content":"RecentSearches_content__160OY"};